import React from "react";

const FileInput = ({
	id,
	label,
	register,
	validationSchema,

	...inputProps
}) => {
	return (
		<div className="mt-2">
			<label
				htmlFor={id}
				className="block mb-2 text-sm font-medium text-gray-900">
				{label}
			</label>
			<input
				className="block w-full text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50"
				id={id}
				name={id}
				{...inputProps}
				{...register(id, validationSchema)}
			/>
		</div>
	);
};

export default FileInput;
